import { Modal } from "@/shared/ui/modal"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { SubmitHandler, useForm } from "react-hook-form"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { closeDeleteGroupModal, fetchDeleteGroup, selectIsDeleteGroupModalOpen, selectOnDelete, selectCurrentGroup, selectCurrentRole } from "../../model"
import { removeGroup } from "@/entities/groups"

export const DeleteGroupModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsDeleteGroupModalOpen)
    const onDelete = useAppSelector(selectOnDelete)
    const currentGroup = useAppSelector(selectCurrentGroup)
    const currentRole = useAppSelector(selectCurrentRole)

    const handleClose = () => {
        dispatch(closeDeleteGroupModal())
    }

    const onSubmit: SubmitHandler<{}> = async () => {
        await new Promise((res, rej) => {
            dispatch(fetchDeleteGroup())
                .unwrap()
                .then(() => {
                    dispatch(removeGroup({ groupId: currentGroup.id, role: currentRole }))
                    notify.success('Группа успешно удалена')
                    reset()
                    res('')
                    onDelete?.()
                    handleClose()
                }).catch((e) => {
                    notify.error(getErrorMessage(e))
                    rej()
                })
        })
    }

    const {
        handleSubmit,
        reset,
        formState: {
            isSubmitting
        }
    } = useForm()

    return (
        <Modal
            isOpen={isOpen}
            title="Удаление группы"
            onRequestClose={handleClose}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <div>
                    Вы уверены, что хотите удалить выбранную группу?
                </div>
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        Удалить
                    </button>
                </div>
            </form>
        </Modal>
    )
}